import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch, type RouteComponentProps } from 'react-router-dom';
import useApplicationOffer from 'products/nomad_insurance/hooks/useApplicationOffer';
import { fetchUserProfile } from 'state/app';
import ThankYou from './components/ThankYou';
import StepRoutes from './steps/routes';
import Price from './components/Price';
import { StepNavigationProvider } from './context';
import { Container } from './styled';

type PurchaseProps = RouteComponentProps;

const Purchase = ({ match }: PurchaseProps) => {
  const dispatch = useDispatch();

  useApplicationOffer();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, []);

  return (
    <StepNavigationProvider flowPath={match.path}>
      <Container bg="fountainBlue">
        <Switch>
          {/*
            Thank you page is not really a step, and has a different layout than the steps
            so it is a separate view
          */}
          <Route
            exact
            path="/nomad-insurance/purchase-insurance/thank-you"
            component={ThankYou}
          />

          {/* Steps */}
          <Route path="*">
            <StepRoutes />
            <Price />
          </Route>
        </Switch>
      </Container>
    </StepNavigationProvider>
  );
};

export default Purchase;
